import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from '../../auth.service';
import { SnackbarService } from 'src/app/shared/snackbar.service';
import { SnackbarPannelClass } from 'src/app/shared/snackbar-panel';
import {LoginResponse} from '../roles/roles.module';
import { Router } from '@angular/router';


@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.scss']
})



export class LogInComponent implements OnInit {
 loginForm!: FormGroup;
 hide = true;
responseData:any

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private snackbarService: SnackbarService,
  private route:Router) { }

  ngOnInit(): void {
      this.loginForm = this.fb.group({
      username: [''],
      password: ['']
    });
  }

  forgotPassword(){
         this.route.navigate(['/forgot-password']);
  }


logIn(){
  const username = this.loginForm.value.username;
  const password = this.loginForm.value.password;

  console.log('🔓 Attempting login for user:', username);

  this.authService.logIn(username, password).subscribe({
    next: (response) => {
      this.responseData = response;

      // ✅ Use AuthService methods to save token and roles
      this.authService.saveToken(this.responseData.token);
      this.authService.saveRoles(this.responseData.roles);

      console.log('✅ Login successful for', username);
      console.log('   Token:', this.responseData.token.substring(0, 20) + '...');
      console.log('   Roles:', this.responseData.roles);

      if(this.authService.isAdmin()){
        console.log('🔐 Admin user - redirecting to /stolbovi');
        this.route.navigate(['/stolbovi']);
      }
      else if (this.authService.isUser()) {
        console.log('👤 Regular user - redirecting to /add');
        this.route.navigate(['/add'])
      }

    },
    error: (error) => {
      console.error('❌ Login failed:', error);
      this.snackbarService.showSnackbar('Настана грешка. Обидете се повторно.', SnackbarPannelClass.Error)
    }
  });
}



  clearUser(){
    console.log('clearUser');
  this.loginForm.get('username')?.setValue('');

  }
  clearPassword(){
    this.loginForm.get('password')?.setValue('');
  }
}
